import React from 'react';
import { useAuthStorageSync } from '../utils/hooks/useAuthStorageSync';
import useGlobalSocket from '../utils/hooks/useGlobalSocket';
import useFirebaseNotifications from '../utils/hooks/useFirebaseNotifications';

// Component that runs global side‑effects after QueryClientProvider is in place
const AppInitializer = () => {
  useAuthStorageSync();
  useGlobalSocket();
  useFirebaseNotifications();
  return null;
};

export default AppInitializer;
